module.exports = __webpack_public_path__ + "static/media/Camila_Montadon_Premium_Site.4c40fdc2.jpg";